import { useMemo } from 'react'
import { useUsuariosOrg } from '@/hooks/useUsuarios'

/**
 * Hook to resolve user emails to display names.
 * Returns a function: resolveNombre(email) => "Nombre Apellido" or email prefix
 */
export function useUserNameResolver() {
  const { data: usuarios = [] } = useUsuariosOrg({ activo: true })

  const emailToName = useMemo(() => {
    const map = new Map<string, string>()
    for (const u of usuarios) {
      if (u.nombre) {
        map.set(u.email, u.nombre)
      }
    }
    return map
  }, [usuarios])

  return (email: string): string => {
    return emailToName.get(email) ?? email.split('@')[0]
  }
}
